<!-- <p>unverified-email works!</p> -->
<div class="content" style="background-color: darkgrey; height: 100%;">
    <div class="content-center" style="color: whitesmoke;">
        <br>
        <h1  style="color: white;">Email Unverified</h1>
        <h2  style="color: whitesmoke;">You cannot use PrismPdM until you verify your email. Check your inbox or contact your account manager.</h2>
        <br>

        <div class="content" style=" background-color: blue;justify-content: center; height: 4em;padding: 0px;border-radius: 0.5em;"
            routerLink="">
            <span>Return to Login</span>
        </div>

    </div>
</div>
